export default __webpack_public_path__ + "static/media/normal_grid.71dbfdc7.svg";